module.exports = __webpack_public_path__ + "DINNextLTPro-MediumItalic.eot?07a11669b2b6dd054b639c1aa9d770de";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-MediumItalic.eot
// module id = 322
// module chunks = 0